namespace $ { $mol_style_attach( "hyoo/draw/colors/colors.view.css",
 "[hyoo_draw_colors] {\n\tflex-direction: column;\n}\n\n\n[hyoo_draw_colors_option][mol_check_checked=\"true\"] {\n\tbox-shadow: inset 0 0 0px 2px var(--mol_theme_back);\n}\n"
) }